import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
import {LookupService} from "../srvs/lookup";

@Component({
  selector: 'micro-ussdSessionLog-detail',
  templateUrl: './ussdSessionLog-detail.component.html'
})
export class UssdSessionLogDetailComponent extends BaseComponent {
  ussdSessionLog:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              public lookupService:LookupService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/ussd/ussdSessionLogs/${id}`).subscribe(
            data => {
              this.setUssdSessionLog(data)
            }
          );
        }
      });
  }

  setUssdSessionLog(ussdSessionLog:any) {
    this.ussdSessionLog = ussdSessionLog;
  }

  createNew() {
    this.ussdSessionLog = {
    };
  }

  save() {
    if (!this.ussdSessionLog.id) {
      this.http.post(`${this.env.e.url}/ussd/ussdSessionLogs`, this.ussdSessionLog)
        .subscribe(
          data => {
            this.setUssdSessionLog(data)
            this.alertService.info(`Created ${this.ussdSessionLog.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/ussd/ussdSessionLogs/${this.ussdSessionLog.id}`, this.ussdSessionLog)
        .subscribe(
          data => {
            this.setUssdSessionLog(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/ussd/ussdSessionLogs/${this.ussdSessionLog.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.ussdSessionLog.name}`);
          this.router.navigate(["/ussdSessionLogs"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
